import React from 'react';
import { YStack } from '@tamagui/stacks';
import { COLORS } from '@/constants/colors';
import {
  PHOTO_INDICATOR_ACTIVE_SIZE,
  PHOTO_INDICATOR_INACTIVE_SIZE,
  PHOTO_INDICATOR_MARGIN,
  BADGE_BORDER_RADIUS,
} from './constants';

type PhotoIndicatorProps = {
  photoCount: number;
  currentIndex: number;
};

const PhotoIndicator: React.FC<PhotoIndicatorProps> = ({ photoCount, currentIndex }) => {
  if (photoCount <= 1) return null;

  return (
    <YStack
      paddingHorizontal="$2"
      paddingVertical="$2"
      borderRadius={BADGE_BORDER_RADIUS}
      backgroundColor={COLORS.WHITE_90}
      alignItems="center"
    >
      {Array.from({ length: photoCount }).map((_, idx) => (
        <YStack
          key={idx}
          width={idx === currentIndex ? PHOTO_INDICATOR_ACTIVE_SIZE : PHOTO_INDICATOR_INACTIVE_SIZE}
          height={idx === currentIndex ? PHOTO_INDICATOR_ACTIVE_SIZE : PHOTO_INDICATOR_INACTIVE_SIZE}
          borderRadius={BADGE_BORDER_RADIUS}
          backgroundColor={COLORS.ZINC_900}
          marginVertical={PHOTO_INDICATOR_MARGIN}
        />
      ))}
    </YStack>
  );
};

export default PhotoIndicator;
